export enum GutterSize {
  XXLARGE = 'xx-large',  // 24px
  XLARGE  = 'x-large',   // 20px
  LARGE   = 'large',     // 16px
  MEDIUM  = 'medium',    // 12px
  SMALL   = 'small',     // 8px
  XSMALL  = 'x-small',   // 4px
  NONE    = 'none',      // 0px
}

export enum TextSize {
  XXLARGE = 'xx-large',  // font-size 2.4rem, line-height 2.8rem
  XLARGE  = 'x-large',   // font-size 2.2rem, line-height 2.8rem
  LARGE   = 'large',     // font-size 1.8rem, line-height 2.4rem
  MEDIUM  = 'medium',    // font-size 1.5rem, line-height 2.0rem
  SMALL   = 'small',     // font-size 1.2rem, line-height 1.2rem
  XSMALL  = 'x-small',   // font-size 1.0rem, line-height 1.0rem
  XXSMALL = 'xx-small',  // font-size 0.8rem, line-height 0.8rem
}

export enum TextColor {
  BLACK = 'black',
  GRAY = 'grey',
}
